import { CommissaryTransferFilters } from '@reliance/types/filters/CommissaryTransferFilters';
import { CommissaryTransfer } from '@reliance/types/models/CommissaryTransfer';
import { useAsync } from 'react-async-hook';
import { IPaginatedResponse } from 'relcore-central';
import api from '../common/api';
import { useMemo } from 'react';

export const useCommissaryTransfers = (filters?: CommissaryTransferFilters) => {
  return useAsync<IPaginatedResponse<CommissaryTransfer>>(
    () => api.get<IPaginatedResponse<CommissaryTransfer>>('/inmate-account/commissary-transfer', {
      params: filters
    }).then(r => r.data),
    [filters]
  );
};

export const useCommissaryTransfersByFacility = (facilityId: number) => {
  const filters = useMemo(() => ({
    facilityId,
    page: -1,
    perPage: 1000,
    orderBy: '-dateEntered'
  }), [facilityId]);

  return useCommissaryTransfers(filters);
};

export const useCommissaryTransfersByInmate = (inmateId: number) => {
  const filters = useMemo(() => ({
    inmateId,
    page: -1,
    perPage: 1000,
    orderBy: '-dateEntered'
  }), [inmateId]);

  return useCommissaryTransfers(filters);
};